/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Coach_Manage_Row_MenuInputs */

const en_us2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Options for the conversation ${i?.title}`)
};

const pt_br2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opções da conversa ${i?.title}`)
};

const es_419_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opciones de la conversación ${i?.title}`)
};

const pt_pt2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opções da conversa ${i?.title}`)
};

const fr_fr2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Options de la conversation ${i?.title}`)
};

const de_de2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Optionen für die Unterhaltung ${i?.title}`)
};

const it_it2_coach_manage_row_menu = /** @type {(inputs: Coach_Manage_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opzioni della conversazione ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Options for the conversation {title}" |
*
* @param {Coach_Manage_Row_MenuInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_row_menu = /** @type {((inputs: Coach_Manage_Row_MenuInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Row_MenuInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_row_menu(inputs)
	if (locale === "es-419") return es_419_coach_manage_row_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_row_menu(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_row_menu(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_row_menu(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_row_menu(inputs)
	return en_us2_coach_manage_row_menu(inputs)
});
export { coach_manage_row_menu as "coach-manage.row_menu" }